function initCustomCarousels(container = document) {
  const carousels = container.querySelectorAll('[data-carousel]');

  carousels.forEach((carousel) => {
    if (carousel.dataset.carouselInitialized === 'true') return;

    const track = carousel.querySelector('[data-carousel-track]');
    const prevButton = carousel.querySelector('[data-carousel-prev]');
    const nextButton = carousel.querySelector('[data-carousel-next]');

    if (!track || !prevButton || !nextButton) return;

    carousel.dataset.carouselInitialized = 'true';

    const scrollAmount = () => Math.max(track.clientWidth * 0.75, 240);

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const hasOverflow = maxScroll > 1;

      if (!hasOverflow) {
        prevButton.hidden = true;
        nextButton.hidden = true;
        return;
      }

      prevButton.hidden = track.scrollLeft <= 1;
      nextButton.hidden = track.scrollLeft >= maxScroll - 1;
    };

    prevButton.addEventListener('click', () => {
      track.scrollBy({
        left: -scrollAmount(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({
        left: scrollAmount(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    requestAnimationFrame(updateButtons);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initCustomCarousels();
  });
} else {
  initCustomCarousels();
}

document.addEventListener('shopify:section:load', (event) => {
  initCustomCarousels(event.target);
});